module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-image col-12"
  }, [_c('div', {
    staticClass: "add-image__title"
  }, [_vm._v("Фотографии")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.files), function(image) {
    return _c('div', {
      key: image.id,
      staticClass: "position-relative col-3"
    }, [_c('div', {
      staticClass: "add-image__image",
      on: {
        "click": function($event) {
          _vm.handleImage(image.fullPath)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": image.fullPath
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "add-image__delete",
      on: {
        "click": function($event) {
          _vm.removeFile(image.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times fa-2x"
    })])])
  }), _vm._v(" "), (_vm.maxFiles !== false) ? _c('div', {
    staticClass: "add-image__image col-3"
  }, [_c('div', {
    staticClass: "add-image__add-button",
    class: {
      'add-image__add-button--loading': _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.inputInit()
      }
    }
  }, [_c('div', {
    staticClass: "text-center pt-2"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-3x",
    class: {
      'fa-spin': _vm.loading
    }
  }), _vm._v(" "), (_vm.loading) ? _c('p', [_vm._v("Сохранение...")]) : _c('p', [_vm._v(_vm._s(_vm.maxFiles))])])])]) : _vm._e()], 2), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "name": "img",
      "multiple": "",
      "accept": _vm.acceptTypes
    },
    on: {
      "change": _vm.beforeOnFileChange
    }
  }), _vm._v(" "), _c('Lightbox', {
    attrs: {
      "visible": _vm.visible,
      "imgs": _vm.imgUrls,
      "index": _vm.index
    },
    on: {
      "hide": function($event) {
        _vm.handleImage('')
      }
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-68328e8c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-68328e8c"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Techcenter/components/TcAddImages.vue
// module id = 1045
// module chunks = 1